// extracted by mini-css-extract-plugin
export default {"tableCss":"AgreementBulkConfirm_tableCss__5mP-l","tdandthCss":"AgreementBulkConfirm_tdandthCss__eRBSX","error":"AgreementBulkConfirm_error__xAJil"};